import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgManagedCorax = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-managed-corax';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.32 2.281c-3.738.268-7.054 2.696-8.38 6.138-.483 1.252-.672 2.26-.672 3.581 0 2.18.648 4.124 1.952 5.86a9.8 9.8 0 0 0 6.18 3.756c2.248.385 4.716-.09 6.648-1.28.556-.342 1.424-.989 1.43-1.065.005-.066-.97-1.109-1.013-1.082-.025.015-.171.13-.325.255a7.5 7.5 0 0 1-1.48.936c-1.192.583-2.365.859-3.648.86a8.235 8.235 0 0 1-8.251-8.242c-.009-3.904 2.752-7.282 6.605-8.076a8.28 8.28 0 0 1 5.254.676c.493.239 1.245.718 1.6 1.018.11.094.22.182.245.196.027.016.246-.196.537-.52l.49-.548-.176-.158c-.786-.706-2.049-1.427-3.176-1.813-1.121-.385-2.62-.577-3.82-.492m7.297 7.002a2.6 2.6 0 0 0-1.522.747c-.299.291-.541.648-.661.977l-.085.233H10v1.52h6.349l.085.233c.186.51.673 1.082 1.171 1.378.14.083.399.199.575.257.277.091.387.105.82.105s.543-.014.82-.105c.44-.146.781-.357 1.116-.692s.546-.676.692-1.116c.091-.277.105-.387.105-.82s-.014-.543-.105-.82c-.425-1.294-1.642-2.06-3.011-1.897m.911 1.59c.239.117.481.359.599.599.133.27.133.787 0 1.057-.464.943-1.795.943-2.252 0a1.43 1.43 0 0 1-.074-.871c.097-.348.43-.703.785-.838.232-.088.708-.061.942.053"
    })
  }));
});
export default SvgManagedCorax;